module.exports = __webpack_public_path__ + "img/148x43_whiteupanddown.c3827afa.png";